import { render, staticRenderFns } from "./NewProductDetails.vue?vue&type=template&id=cb90d83c&scoped=true"
import script from "./NewProductDetails.vue?vue&type=script&lang=js"
export * from "./NewProductDetails.vue?vue&type=script&lang=js"
import style0 from "./NewProductDetails.vue?vue&type=style&index=0&id=cb90d83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb90d83c",
  null
  
)

export default component.exports